import React from 'react';
import { motion } from 'framer-motion';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import Footer from './Footer';
import TrialBanner from './TrialBanner';
import EnhancedApiTokenBanner from './EnhancedApiTokenBanner';
import NavigationDrawerManager from '../social-media/NavigationDrawerManager';
import { isSubscriptionsEnabled } from '../../utils/featureFlags';

interface LayoutProps {
  children: React.ReactNode;
  sidebarCollapsed?: boolean;
  onSidebarToggle?: () => void;
}

const Layout: React.FC<LayoutProps> = ({
  children,
  sidebarCollapsed = false,
  onSidebarToggle,
}) => {
  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggle={onSidebarToggle}
      />

      <div className="flex-1 flex flex-col overflow-hidden">
        {isSubscriptionsEnabled() && (
          <TrialBanner />
        )}
        <EnhancedApiTokenBanner />
        <TopBar />

        <motion.main
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          className="flex-1 overflow-y-auto p-6"
        >
          {children}
        </motion.main>

        <Footer />
      </div>

      {/* Global drawer navigation manager */}
      <NavigationDrawerManager />
    </div>
  );
};

export default Layout;